import { render, staticRenderFns } from "./DeleteContentModal.vue?vue&type=template&id=24a46942"
import script from "./DeleteContentModal.vue?vue&type=script&lang=js"
export * from "./DeleteContentModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteContentModal.vue?vue&type=style&index=0&id=24a46942&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports